module.exports = __webpack_public_path__ + "media/40_Long.ba93bd0b.mp3";